import { useState } from 'react'

function maskValue(value: string): string {
  if (value.length <= 4) return value
  return '•'.repeat(value.length - 4) + value.slice(-4)
}

const EyeIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
  </svg>
)

const EyeOffIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
  </svg>
)

interface MaskedFieldProps {
  label: string
  value?: string | null
  variant?: 'inline' | 'stacked'
}

export function MaskedField({ label, value, variant = 'stacked' }: MaskedFieldProps) {
  const [visible, setVisible] = useState(false)

  if (!value) {
    if (variant === 'inline') {
      return (
        <div>
          <span className="text-gray-500">{label}:</span>{' '}
          <span className="text-gray-900">-</span>
        </div>
      )
    }
    return (
      <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="font-medium text-gray-900">-</p>
      </div>
    )
  }

  const displayed = visible ? value : maskValue(value)

  if (variant === 'inline') {
    return (
      <div className="flex items-center gap-2">
        <span className="text-gray-500">{label}:</span>
        <span className="text-gray-900 font-mono text-sm">{displayed}</span>
        <button
          type="button"
          onClick={() => setVisible(v => !v)}
          className="text-gray-400 hover:text-gray-600 transition-colors"
          title={visible ? 'Hide' : 'Show'}
        >
          {visible ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      </div>
    )
  }

  return (
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <div className="flex items-center gap-2 mt-0.5">
        <p className="font-medium text-gray-900 font-mono">{displayed}</p>
        <button
          type="button"
          onClick={() => setVisible(v => !v)}
          className="text-gray-400 hover:text-gray-600 transition-colors"
          title={visible ? 'Hide' : 'Show'}
        >
          {visible ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      </div>
    </div>
  )
}
